<div class="chart enable-graph-container">
  <span class="enable-graph-label" style="padding-right: 10px !important;">Enable feature</span><input type="checkbox" [checked]="enableChecked"
  class="primary-checkbox" id="EnableGraph" (change)="enableGraph($event.target.checked)" />
  <!-- added id here -->
  <label for="EnableGraph"><span id="CloLite-enable-feature-checkbox" class="extra-border-enablefeat"></span></label>
</div>
<div class="row clo-table-container blockCss" style="margin-left: 41px;">
  <div class="col-2">
    <div class="schedule">Schedule</div>
  </div>
  <div class="col-10">
    <!-- added id here -->
    <div id="CLO-chart-container" class="chart container" [ngClass]="disableGraph ? 'disable-graph' : 'enable-graph'">

      <ul ngbNav #nav="ngbNav" [activeId]="activeIdString" (navChange)="tabChanged($event)" class="nav-tabs">
        <li ngbNavItem="1" [ngClass]="disableGraph ? 'nav-item nav-link' : 'nav-item active'">
          <a ngbNavLink>Numeric generator</a>
          <ng-template ngbNavContent>
            <!-- added id here -->
            <div style="text-align: right;">
              <button id="CloLite-clear-numericFields"
                type="button"
                class="numeric-clear"
                style="border: none;"
                [disabled]="disableNumericClear"
                (click)="clearNumericFields()"
                [ngClass]="{'disable-numeric-clear': disableNumericClear===true}">
                Clear fields
              </button>
            </div>
            <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>
              @if (cloLiteSchema?.properties?.CloLiteMaximumWorkingHours) {
                <div class="row chart-rows">
                  <div class="col-5">CLO active hours</div>
                  <div class="col-7 form-group">
                    <input type="text"
                      id="CloLite-activeHours-input" class="form-control" formControlName="cloHour" maxlength="6" size="4" (keypress)="numberOnly($event)"
                      [ngClass]="{ 'is-invalid': submitted && f.cloHour.errors, 'initial-input': afterClearField===true }"
                      (keyup)="inputValueChanged($event)" /><span class="field-suffix" style=" padding-left: 0.5em;">x 1000 h</span>
                    </div>
                  </div>
                }
                @if (cloLiteSchema?.properties?.CloLiteNumberOfSteps) {
                  <div class="row chart-rows">
                    <div class="col-5">Number of steps</div>
                    <div class="col-7 form-group">
                      <input type="text"
                        id="CloLite-steps-input" class="form-control" formControlName="cloSteps" maxlength="3" size="4" (keypress)="numberOnly($event)"
                        [ngClass]="{ 'is-invalid': submitted && f.cloSteps.errors, 'initial-input': afterClearField===true }"
                        (keyup)="inputValueChanged($event)" />
                      </div>
                    </div>
                  }
                  @if (cloLiteSchema?.properties?.CloLiteInitialPowerLevel) {
                    <div class="row chart-rows">
                      <div class="col-5">Initial output level</div>
                      <div class="col-7 form-group">
                        <input type="text"
                          id="CloLite-initialOutputLevel-input" class="form-control" formControlName="initialOutput" maxlength="3" (keypress)="numberOnly($event)"
                          size="4"
                          [ngClass]="{ 'is-invalid': submitted && f.initialOutput.errors, 'initial-input': afterClearField===true }"
                          (keyup)="inputValueChanged($event)" /><span class="field-suffix" style=" padding-left: 0.5em;"> %</span>
                        </div>
                      </div>
                    }
                    @if (cloLiteSchema?.properties?.CloLiteFinalPowerLevel) {
                      <div class="row chart-rows">
                        <div class="col-5">Final output level</div>
                        <div class="col-7 form-group">
                          <input type="text"
                            id="CloLite-finalOutputLevel-input" class="form-control" formControlName="finalOutput" maxlength="3" (keypress)="numberOnly($event)"
                            size="4"
                            [ngClass]="{ 'is-invalid': submitted && f.finalOutput.errors, 'initial-input': afterClearField===true }"
                            (keyup)="inputValueChanged($event)" /><span class="field-suffix" style=" padding-left: 0.5em;"> %</span>
                          </div>
                        </div>
                      }
                    </form>
                  </ng-template>
                </li>
              </ul>
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
        <br>
